import { canadaFooterData } from "../../data/canadaTaxData";

export const CanadaFooter = () => (
  <footer className="bg-[#070F1A] border-t border-white/5 py-10 px-6 text-center">
    <p className="text-[#D4A843] font-black text-lg mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
      {canadaFooterData.brandName}
    </p>
    <p className="text-[#8BA3BE] text-xs leading-loose mb-4" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
      {canadaFooterData.tagline}
      <br />
      {canadaFooterData.subline}
    </p>
    <div className="flex justify-center items-center gap-4 text-xs text-[#5A6A7A] mb-4" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
      <a href="#" className="hover:text-[#D4A843] transition-colors duration-200">Privacy Policy</a>
      <span>·</span>
      <a href="#" className="hover:text-[#D4A843] transition-colors duration-200">Terms of Service</a>
      <span>·</span>
      <a href="#" className="hover:text-[#D4A843] transition-colors duration-200">Contact</a>
    </div>
    <p className="text-[#5A6A7A] text-[11px] max-w-xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
      {canadaFooterData.disclaimer}
    </p>
  </footer>
);
